module.exports = {"unit":{"meter":"meter","square":"square meter","cubic":"cubic meter","piece":"piece","flatrate":"flat rate","kilo_watt_hours":"kilo watt hours"},"time":{"month":"month","quartal":"quarter","year":"year"},"currency":{"euro":"Euro","dollar":"Dollar"}};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/culture.php
// module id = 6UW0
// module chunks = 1